import { setValue } from "./skyward.ui.controls";
import { registerEvents } from "./skyward.ui.events";

const events =
{
    resetWaitingMessage,
    resetApprovedMessage,
    resetDeniedMessage
};

registerEvents("cashReceiptSelector", events);

function resetWaitingMessage()
{
    const waitingMessageSubject = $("#editCashReceiptRequest_CashReceiptRequestWaitingMessageSubject");
    const waitingMessageContent = $("#editCashReceiptRequest_CashReceiptRequestWaitingMessageContent");
    const defaultWaitingMessageSubject = "Cash receipt deposit request {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Description} is waiting for your approval";
    const defaultWaitingMessageContent = "{User.Name.FirstName},\n\nCash receipt deposit request {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Description} of batch {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Batch} is waiting for your approval at {TaskInstance.CashReceiptApproval.LevelDescription}.";

    setValue(waitingMessageSubject, defaultWaitingMessageSubject, false);
    setValue(waitingMessageContent, defaultWaitingMessageContent, false);
}

function resetApprovedMessage()
{
    const approvedMessageSubject = $("#editCashReceiptRequest_CashReceiptRequestApprovedMessageSubject");
    const approvedMessageContent = $("#editCashReceiptRequest_CashReceiptRequestApprovedMessageContent");
    const defaultApprovedMessageSubject = "Cash receipt deposit request {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Description} has been approved";
    const defaultApprovedMessageContent = "{CashReceiptDeposit.UserCreatedBy.Name.FirstName},\n\nCash receipt deposit request {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Description} of batch {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Batch} has been approved at {TaskInstance.CashReceiptApproval.LevelDescription}.";

    setValue(approvedMessageSubject, defaultApprovedMessageSubject, false);
    setValue(approvedMessageContent, defaultApprovedMessageContent, false);
}

function resetDeniedMessage()
{
    const deniedMessageSubject = $("#editCashReceiptRequest_CashReceiptRequestDeniedMessageSubject");
    const deniedMessageContent = $("#editCashReceiptRequest_CashReceiptRequestDeniedMessageContent");
    const defaultDeniedMessageSubject = "Cash receipt deposit request {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Description} has been denied";
    const defaultDeniedMessageContent = "CashReceiptDeposit.UserCreatedBy.Name.FirstName},\n\nCash receipt deposit request {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Description} of batch {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Batch} has been denied at {TaskInstance.CashReceiptApproval.LevelDescription}.\n\nDenial Reason: {Comment}";

    setValue(deniedMessageSubject, defaultDeniedMessageSubject, false);
    setValue(deniedMessageContent, defaultDeniedMessageContent, false);
}
